export interface Material {
  id: string
  name: string
  brand: string
  category: "shingle" | "underlayment" | "accessory" | "ventilation" | "flashing" | "fastener" | "sealant"
  unit: string
  pricePerUnit: number
}

export interface LaborItem {
  id: string
  name: string
  unit: string
  pricePerUnit: number
  regionMultipliers: Record<string, number>
}

export interface SpecialFeature {
  id: string
  name: string
  unit: string
  price: number
}

export const shingleOptions = [
  { id: "mat_001", name: "Timberline HDZ", brand: "GAF", pricePerUnit: 4.50, warranty: "Lifetime Limited" },
  { id: "mat_002", name: "Duration", brand: "Owens Corning", pricePerUnit: 4.50, warranty: "Lifetime Limited" },
  { id: "mat_003", name: "Cambridge", brand: "CertainTeed", pricePerUnit: 4.50, warranty: "Lifetime Limited" },
  { id: "mat_004", name: "Heritage", brand: "Tamko", pricePerUnit: 4.50, warranty: "30-Year Limited" },
] as const

export const materials: Material[] = [
  // Underlayment
  { id: "mat_010", name: "Synthetic Underlayment", brand: "GAF", category: "underlayment", unit: "sqft", pricePerUnit: 0.15 },
  { id: "mat_011", name: "Ice & Water Shield", brand: "Grace", category: "underlayment", unit: "sqft", pricePerUnit: 0.85 },
  // Accessories
  { id: "mat_020", name: "Starter Strip Plus", brand: "GAF", category: "accessory", unit: "linear_ft", pricePerUnit: 0.75 },
  { id: "mat_021", name: "Hip & Ridge Shingles", brand: "GAF", category: "accessory", unit: "linear_ft", pricePerUnit: 2.50 },
  { id: "mat_022", name: "Cobra Ridge Vent", brand: "GAF", category: "ventilation", unit: "linear_ft", pricePerUnit: 3.25 },
  { id: "mat_023", name: "Drip Edge", brand: "Generic", category: "flashing", unit: "linear_ft", pricePerUnit: 0.45 },
  // Fasteners
  { id: "mat_030", name: "Coil Nails", brand: "Generic", category: "fastener", unit: "sqft", pricePerUnit: 0.08 },
  // Sealant
  { id: "mat_040", name: "Roof Sealant", brand: "Geocel", category: "sealant", unit: "tube", pricePerUnit: 8.50 },
]

export const laborItems: LaborItem[] = [
  {
    id: "lab_001",
    name: "Roof Installation Labor",
    unit: "sqft",
    pricePerUnit: 3.50,
    regionMultipliers: { midwest: 1.0, west: 1.3, northeast: 1.2, south: 0.9, southwest: 1.05 },
  },
  {
    id: "lab_002",
    name: "Tear Off (1 layer)",
    unit: "sqft",
    pricePerUnit: 1.25,
    regionMultipliers: { midwest: 1.0, west: 1.2, northeast: 1.15, south: 0.95, southwest: 1.0 },
  },
  {
    id: "lab_003",
    name: "Dump & Haul Off",
    unit: "sqft",
    pricePerUnit: 0.35,
    regionMultipliers: { midwest: 1.0, west: 1.15, northeast: 1.1, south: 0.9, southwest: 0.95 },
  },
]

export const specialFeatures: SpecialFeature[] = [
  { id: "spe_002", name: "Skylight Flashing", unit: "each", price: 250 },
  { id: "spe_003", name: "Chimney Flashing", unit: "each", price: 450 },
  { id: "spe_004", name: "Multi-Story Surcharge", unit: "sqft", price: 0.50 },
  { id: "spe_005", name: "Asbestos Abatement", unit: "sqft", price: 2.50 },
]
